exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-header-title label {\n  font-weight: 700;\n  font-size: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/fuel_surcharges/edit/fuel_surcharges.edit.scss
// module id = 1121
// module chunks = 1